import axios from './index'

class home {
    // 获取新人优惠券
    static getCoupon(params) {
        return axios.post('/nice-api-customer/v1/customZoneActivity/draw', params)
    }

    // 获取新人优惠券步骤
    static getCouponStep(options) {
        return axios.get('/nice-api-customer/v1/customZoneActivity/label', {params:options})
    }

    // 获取新人优惠券(已登录)
    static getCouponList2(options) {
        return axios.get('/nice-api-customer/v1/customZoneActivity/zone', {params:options})
    }

    // 获取新人优惠券(未登录)
    static getCouponList1(options) {
        return axios.get('/nice-api-customer/v1/customZoneActivity/default', {params:options})
    }

    //查询养护服务列表
    static curingServiceGoods(options) {
        return axios.get('/nice-api-curing-service/v1/curingServiceGoods/all', {params:options})
    }

    static curingServiceGoodsPart(options) {
        return axios.get('/nice-api-curing-service/v1/curingServiceGoods', {params:options})
    }
    

    //查询养护服务列表(根据品类)
    static curingServiceGoodsCategoty(options) {
        return axios.get('/nice-api-curing-service/v1/curingServiceGoods', {params:options})
    }
  
    //查询单个服务详情
    static serviceDetail(options) {
        return axios.get(`/nice-api-curing-service/v1/curingServiceGoods/${options}`)
    }

    //查询热门推荐
    static getHot(options) {
        return axios.get(`/nice-api-curing-service/v1/curingServiceGoods/hot`)
    }


    //添加服务
    static shoppingCart(options) {
        return axios.post(`/nice-api-order/v1/shoppingCart`,options)
    }

    //获得购物车服务

    static getShoppingCart(options) {
        return axios.get(`/nice-api-order/v1/shoppingCart`,{params:options})
    }
    
    //保存购物车

    static submitCart(options) {
        return axios.post(`/nice-api-order/v1/shoppingCart/submit`,options)
    }

    //根据areacode判断是否包邮

    static freePostage(options) {
        return axios.post(`/nice-api-order/v1/chinaArea/${options}/freePostage`)
    }
    
    // 获取购物车服务数量
    static shoppingCartcount(options) {
        return axios.get(`/nice-api-order/v1/shoppingCart/count`)
    }

    // 更新购物车服务数量
    static updataShoppingCart(options) {
        return axios.post(`/nice-api-order/v1/shoppingCart/update`,options)
    }
    
    // 清空购物车
    static clearBag(param) {
        return axios.delete(`/nice-api-order/v1/shoppingCart`,{data : param})
    }
    //包拯618专用
    static selectAllGoods() {
        return axios.get(`/nice-api-order/v1/goods/customer/all`)
    }


    static selectOther(customerId) {
        return axios.get(`/nice-api-order/v1/goods/${customerId}/all`)
    }
    //获得首页各种已售数量
    static salesNumbers(params) {
        return axios.get(`/nice-api-curing-service/v1/curingServiceGoods/${params.ids}/salesNumber`)
    }

    //获得咨询单信息预览
    static consultationOrder(id) {
        return axios.get(`/nice-api-order/v1/consultationOrder/${id}`)
    }

    //用户与咨询单做绑定
    static consultationSend(id){
        return axios.patch(`/nice-api-order/v1/consultationOrder/${id}/send`)
    }

    //用户与咨询单做绑定
    static consultationCheck(id){
        return axios.patch(`/nice-api-order/v1/consultationOrder/${id}/check`)
    }

    //顺丰时间规则
    static listPickDateAndTime(params){
        return axios.post(`/nice-api-order/express/list-pick-datetime`,params)
    }


    //获取拼团活动
    static groupActivity(params){
        return axios.get(`/nice-api-order/v1/groupActivity`)
    }

    //查询顾客参与拼团的记录
    static groupHisActivity(params){
        return axios.get(`/nice-api-order/v1/groupActivity/${params.groupActivityId}/customerRecordDetail`)
    }

    //查询拼团中的拼团记录
    static groupActivityList(params){
        return axios.get(`/nice-api-order/v1/groupActivity/${params}/records`,{headers:{
            NO_LOADING : true
        }})
    }

    //查询拼团记录详情,根据订单编码
    static activityByOrderCode(params){
        return axios.get(`/nice-api-order/v1/groupActivity/record/${params}/byOrderCode`)
    }

    //查询拼团记录详情,根据ID
    static activityById(params){
        return axios.get(`/nice-api-order/v1/groupActivity/record/${params}`)
    }
    

    //校验参与拼团活动资格
    static teamVerify(params){
        return axios.get(`/nice-api-order/v1/groupActivity/record/${params}/verify`)
    }
    
    //校验开启资格
    static teamOpenVerify(params){
        return axios.get(`/nice-api-order/v1/groupActivity/open/${params}/verify`)
    }
    
    //查询拼团奖励列表
    static getAward(options) {
        return axios.get(`/nice-api-order/v1/groupActivity/${options.groupActivityId}/groupActivityAward`);
    }
    //拼团领取奖励
    static getAwardGoods(params) {
        return axios.post(`/nice-api-order/v1/groupActivity/drawGroupActivityAward`,params);
    }
   //拼团客服二维码
   static getWeCode(params) {
        return axios.get(`/nice-api-order/v1/groupActivity/get/servicephone/${params.activiteId}`);
    }

}

export default home;
